import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { QueryBuilderConfigProvider } from '@common/filter/query-builder-config-provider';
import { addFilterFieldsToAdminForm, getDefaultWidgetConfigAdminForm } from '@feature/widget-admin/services/widget-admin-form';
import { WidgetConfiguration } from '@feature/widget-configs';
import { WidgetAdminHandler } from '@widget-admin/services/widget-admin-handler';
import { FormDefinition  } from '@feature/_app_modules/dynamic-forms/dynamic-form';
import { AdminCallsWidgetFilterFieldProvider } from '../filters/admin-calls-widget-filter-field-provider';
import { WidgetDefaultColumnHandlerService } from '@feature/_app_modules/debtor-account-history-widget/services/widget-default-column-handler.service';

@Injectable({
  providedIn: 'root'
})
export class CallsWidgetAdminHandler implements WidgetAdminHandler {

  constructor(
    private readonly defaultColumnAdminHandler: WidgetDefaultColumnHandlerService
  ) { }

  initialise(): boolean | Observable<boolean> {
    return true;
  }
  getAdminForm(selectedConfig: WidgetConfiguration): FormDefinition | Observable<FormDefinition> {

    const result = (this.defaultColumnAdminHandler.getAdminForm(selectedConfig) as Observable<FormDefinition>).pipe(map(formDefinition => {
      const filterFieldProvider = new AdminCallsWidgetFilterFieldProvider(selectedConfig);
      const queryConfigProvider = new QueryBuilderConfigProvider(filterFieldProvider);
      const queryConfig = queryConfigProvider.getQueryBuilderConfig();

      formDefinition = addFilterFieldsToAdminForm(selectedConfig, queryConfig, formDefinition);

      return formDefinition;
    }));

    return result;
  }

  createCopyFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    return this.defaultColumnAdminHandler.createCopyFromAdminForm(selectedConfig, adminFormValue);
  }
  saveConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    return this.defaultColumnAdminHandler.saveConfigFromAdminForm(selectedConfig, adminFormValue);
  }
  deleteConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    return this.defaultColumnAdminHandler.deleteConfigFromAdminForm(selectedConfig, adminFormValue);
  }

}
